<template>
    <div class="projects-learning">

        <div class="content">
            
            <content-switch
            :items="switchItems"
            :selectedItem="selectedItem"
            :counts="counts"
            @selectItem="handleSelectItem($event)" />

            <div class="row" v-show="selectedItem === 'projectTypeRevenue'">
                <div :class="{'col-lg-9': !selectedProjectType, 'col-lg-3': selectedProjectType}">
                    <projectTypeRevenue-table title="Hvilke opgavetyper tjenes der penge på?" @selectProjectType="setSelectedProjectType($event)" @finishedLoading="updateCount('projectTypeRevenue', $event)" />
                </div>
                <div v-if="selectedProjectType" class="col-lg-9">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedProjectType = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                    <showTypeRevenue-table :rows="$store.getters.groupedProjects[selectedProjectType]" title="Konkrete opgaver" />
                </div>
                <div v-else class="col-lg-3">
                    Vælg en opgavetype for at se en liste over alle opgaver og deres konkrete indtjening.
                </div>
            </div>
            
            <closedProjects-table title="Hvilke konkrete opgaver tjenes der penge på?" v-show="selectedItem === 'closedProjectsRevenue'" @finishedLoading="updateCount('closedProjectsRevenue', $event)" />
            
            <project-type-skills v-show="selectedItem === 'projectTypeSkills'" />

            <project-type-development v-show="selectedItem === 'projectTypeDevelopment'" />

            <project-type-coverage-per-hour-development v-show="selectedItem === 'coveragePerHourPerProjectTypeDevelopment'" />

            <project-type-graphs v-show="selectedItem === 'projectTypeGraphs'" />

            <claims-table v-show="selectedItem === 'claims'" @finishedLoading="updateCount('claims', $event)" />

            <minuba-budget-report v-show="selectedItem === 'minubaBudgetReport'" />

            <div class="placeholder">

                <div v-show="selectedItem === 'closedProjectsRevenue'">                        
                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            selectedProjectType: null,
            selectedItem: 'projectTypeRevenue',
            counts: {
                projectTypeRevenue: null,
                closedProjectsRevenue: null,
                claims: null
                // projectTypeSkills: null
                // projectTypeDevelopment: null,
                // coveragePerHourPerProjectTypeDevelopment: null
            },
            switchItems: [
                {
                    name: 'Hvilke opgavetyper tjenes der penge på?',
                    slug: 'projectTypeRevenue'
                },
                {
                    name: 'Hvilke konkrete opgaver tjenes der penge på?',
                    slug: 'closedProjectsRevenue'
                },
                {
                    name: 'Afsluttede reklamationer',
                    slug: 'claims'
                },
                {
                    name: 'Hvilke svende er gode til hvilke opgaver?',
                    slug: 'projectTypeSkills'
                },
                {
                    name: 'Udviklingen i DB / DB pr. time',
                    slug: 'projectTypeGraphs'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        setSelectedProjectType (projectType) {
            this.selectedProjectType = projectType
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        this.$store.state.view = 'learning'
        // if (this.$auth.user().roles[0].name === 'super-admin') {
            if (this.$auth.user().company.api_provider.slug === 'minuba') {
                this.switchItems.push({
                    name: 'Opgavebudgetter',
                    slug: 'minubaBudgetReport'
                })
            }
        // }
    },
    components: {
        'project-type-development': require('./components/projectTypeDevelopment.vue'),
        'project-type-skills': require('./components/projectTypeSkills.vue'),
        'project-type-coverage-per-hour-development': require('./components/projectTypeCoveragePerHourDevelopment.vue'),
        'project-type-graphs': require('./components/projectTypeGraphs.vue'),
        'claims-table': require('../employees/operations/claims.vue'),
        'minuba-budget-report': require('./components/minubaBudgetReport.vue')
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?dd69c7de